/* eslint-disable */
<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3 class="mx-3">Edit</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-form ref="editForm" v-model="valid" lazy-validation>
          <v-combobox
            class="ma-3"
            label="Select Type"
            required
            :rules="rulesType"
            small-chips
            deletable-chips
            @change="updateNameList(selectedType)"
            :items="itemsType"
            v-model="selectedType"
          >
            <v-icon small slot="prepend">
              mdi-apps
            </v-icon>
          </v-combobox>
          <v-combobox
            class="ma-3"
            label="Select Name"
            required
            :rules="rulesName"
            small-chips
            deletable-chips
            @change="getDetailsByName(selectedName)"
            :items="itemsName"
            v-model="selectedName"
          >
            <v-icon small slot="prepend">
              mdi-format-title
            </v-icon>
          </v-combobox>
          <v-text-field class="ma-3" label="Name" v-model="newName"
            ><v-icon small slot="prepend">
              mdi-form-textbox
            </v-icon>
          </v-text-field>
          <v-combobox
            class="ma-3"
            label="Select Tags"
            small-chips
            multiple
            deletable-chips
            :items="itemsTags"
            v-model="selectedTags"
          >
            <v-icon small slot="prepend">
              mdi-tag-multiple
            </v-icon>
          </v-combobox>
          <v-textarea
            class="ma-3"
            rows="2"
            v-model.lazy="description"
            label="Description"
            ><v-icon small slot="prepend">
              mdi-text
            </v-icon>
          </v-textarea>
          <v-text-field
            class="ma-3"
            label="Location"
            v-model.lazy="location"
            v-if="locationShow"
            ><v-icon small slot="prepend">
              mdi-map-marker
            </v-icon>
          </v-text-field>
          <v-text-field
            class="ma-3"
            label="URL"
            v-model.lazy="url"
            v-if="urlShow"
            ><v-icon small slot="prepend">
              mdi-link
            </v-icon>
          </v-text-field>
          <v-switch
            class="ma-3"
            v-model="business"
            flat
            small
            label="Business"
            v-if="businessShow"
          >
            <v-icon small slot="prepend">
              mdi-briefcase-outline
            </v-icon>
          </v-switch>
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="ma-3"
                v-model="startDate"
                label="Start Date"
                readonly
                v-on="on"
                v-show="startDateShow"
                ><v-icon small slot="prepend">
                  mdi-calendar-arrow-left
                </v-icon>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              no-title
              @input="startDateMenu = false"
            >
            </v-date-picker>
          </v-menu>
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="ma-3"
                v-model="endDate"
                label="End Date"
                readonly
                v-on="on"
                v-show="endDateShow"
                ><v-icon small slot="prepend">
                  mdi-calendar-arrow-right
                </v-icon>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              no-title
              @input="endDateMenu = false"
            >
            </v-date-picker>
          </v-menu>
        </v-form>
        <v-row class="justify-center">
          <v-btn
            class="mx-3"
            small
            fab
            color="secondary"
            :disabled="!valid"
            @click="upsertEditRecord"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            class="mx-3"
            small
            fab
            color="warning"
            :disabled="!valid"
            @click="deleteEditRecord"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-snackbar
          v-model="snackbarModel"
          bottom
          :color="snackbarColor"
          :timeout="snackbarTimeout"
        >
          {{ snackbarText }}
          <v-btn dark text @click="snackbarModel = false">
            Close
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { mapState, mapActions } from "vuex";
import getsheetobj from "@/mixins/getsheetobj";

export default {
  name: "Edit",
  mixins: [getsheetobj],
  data: () => ({
    editSheets: [
      "type",
      "spendCategory",
      "transactionType",
      "vendor",
      "payMethod",
      "receipt",
      "trip",
      "taxCategory",
      "exercise",
      "muscleGroup",
      "meals",
      "account",
      "tag",
    ],
  }),
  watch: {
    selectedTags(val, prev) {
      if (!val || !prev) return;
      if (val.length === prev.length) return;

      this.selectedTags = val.map((tag) => {
        // Check if tag is new
        if (typeof tag === "string" && !this.itemsTags.includes(tag)) {
          // create a new row for the tag
          const id = this.sheetsObj["tag"].maxId + 1;
          const uuid = uuidv4();
          const newTag = tag;
          const params = {
            spreadsheetId: this.sheetId,
            valueInputOption: "RAW",
            range: "tag",
            insertDataOption: "INSERT_ROWS",
          };
          const valueRangeBody = {
            majorDimension: "ROWS",
            values: [[id, uuid, newTag]],
          };
          // update the sheet
          this.$gapi.getGapiClient().then((gapi) => {
            gapi.client.sheets.spreadsheets.values
              .append(params, valueRangeBody)
              .then(() => {
                // fecth the updated sheets
                this.getEditFormFields(this.sheetId, this.editSheets);
              });
          });
        }
        // if not new, simply return the tag
        return tag;
      });
    },
  },
  computed: {
    valid: {
      get() {
        return this.$store.state.edit.valid;
      },
      set(value) {
        const payload = {
          state: "valid",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    ...mapState({
      lists: (state) => state.edit.lists,
      itemsType: (state) => state.edit.lists.type,
      rulesType: (state) => state.edit.type.rules,
      itemsName: (state) => state.edit.name.items,
      rulesName: (state) => state.edit.name.rules,
      itemsTags: (state) => state.edit.lists.tag,
      id: (state) => state.edit.name.id,
      uuid: (state) => state.edit.name.uuid,
      snackbarText: (state) => state.edit.snackbar.text,
      snackbarColor: (state) => state.edit.snackbar.color,
      snackbarTimeout: (state) => state.edit.snackbar.timeout,
      locationShow: (state) => state.edit.location.show,
      urlShow: (state) => state.edit.url.show,
      businessShow: (state) => state.edit.business.show,
      startDateShow: (state) => state.edit.dates.startDate.show,
      endDateShow: (state) => state.edit.dates.endDate.show,
      isAuthenticated: (state) => state.auth.isAuthenticated,
      sheetId: (state) => state.sheet.sheetId,
      allSheets: (state) => state.sheet.allSheets,
      sheetsObj: (state) => state.sheet.sheetsObj,
      foodSheet: (state) => state.food.foodSheet,
    }),
    selectedType: {
      get() {
        return this.$store.state.edit.type.selected;
      },
      set(value) {
        const payload = {
          state: "type",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    selectedName: {
      get() {
        return this.$store.state.edit.name.selected;
      },
      set(value) {
        const payload1 = {
          state: "name",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload1);
        const payload2 = {
          state: "name",
          field: "newName",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload2);
      },
    },
    newName: {
      get() {
        return this.$store.state.edit.name.newName;
      },
      set(value) {
        const payload = {
          state: "name",
          field: "newName",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    selectedTags: {
      get() {
        return this.$store.state.edit.tag.selected;
      },
      set(value) {
        const payload = {
          state: "tag",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    description: {
      get() {
        return this.$store.state.edit.description;
      },
      set(value) {
        const payload = {
          state: "description",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    location: {
      get() {
        return this.$store.state.edit.location.value;
      },
      set(value) {
        const payload = {
          state: "location",
          field: "value",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    url: {
      get() {
        return this.$store.state.edit.url.value;
      },
      set(value) {
        const payload = {
          state: "url",
          field: "value",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    business: {
      get() {
        return this.$store.state.edit.business.value;
      },
      set(value) {
        const payload = {
          state: "business",
          field: "value",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    startDate: {
      get() {
        return this.$store.state.edit.dates.startDate.date;
      },
      set(value) {
        const payload = {
          state: "dates",
          field: "startDate",
          subfield: "date",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    startDateMenu: {
      get() {
        return this.$store.state.edit.dates.startDate.menu;
      },
      set(value) {
        const payload = {
          state: "dates",
          field: "startDate",
          subfield: "menu",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    endDate: {
      get() {
        return this.$store.state.edit.dates.endDate.date;
      },
      set(value) {
        const payload = {
          state: "dates",
          field: "endDate",
          subfield: "date",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    endDateMenu: {
      get() {
        return this.$store.state.edit.dates.endDate.menu;
      },
      set(value) {
        const payload = {
          state: "dates",
          field: "endDate",
          subfield: "menu",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
    snackbarModel: {
      get() {
        return this.$store.state.edit.snackbar.model;
      },
      set(value) {
        const payload = {
          state: "snackbar",
          field: "model",
          value: value,
        };
        this.$store.dispatch("edit/updateState", payload);
      },
    },
  },
  methods: {
    ...mapActions({
      updateSheetsObjAct: "sheet/updateSheetsObj",
    }),
    updateNameList(selectedType) {
      switch (selectedType) {
        case "spendCategory":
        case "transactionType":
        case "payMethod":
        case "receipt":
        case "taxCategory":
        case "exercise":
        case "muscleGroup":
        case "foodType":
        case "account":
          this.resetEditFormShow();
          break;
        case "vendor":
          this.resetEditFormShow();
          this.$store.dispatch("edit/updateState", {
            state: "location",
            field: "show",
            value: true,
          });
          this.$store.dispatch("edit/updateState", {
            state: "url",
            field: "show",
            value: true,
          });
          break;
        case "trip":
          this.$store.dispatch("edit/updateState", {
            state: "location",
            field: "show",
            value: true,
          });
          this.$store.dispatch("edit/updateState", {
            state: "url",
            field: "show",
            value: false,
          });
          this.$store.dispatch("edit/updateState", {
            state: "business",
            field: "show",
            value: true,
          });
          this.$store.dispatch("edit/updateState", {
            state: "dates",
            field: "startDate",
            subfield: "show",
            value: true,
          });
          this.$store.dispatch("edit/updateState", {
            state: "dates",
            field: "endDate",
            subfield: "show",
            value: true,
          });
          break;
        default:
          this.resetEditFormShow();
          break;
      }
      this.$store.dispatch("edit/updateState", {
        state: "name",
        field: "selected",
        value: "",
      });
      this.clearDetails();
      this.$store.dispatch("edit/updateState", {
        state: "name",
        field: "items",
        value: this.lists[selectedType],
      });
    },
    resetEditFormShow() {
      this.$store.dispatch("edit/updateState", {
        state: "location",
        field: "show",
        value: false,
      });
      this.$store.dispatch("edit/updateState", {
        state: "url",
        field: "show",
        value: false,
      });
      this.$store.dispatch("edit/updateState", {
        state: "business",
        field: "show",
        value: false,
      });
      this.$store.dispatch("edit/updateState", {
        state: "dates",
        field: "startDate",
        subfield: "show",
        value: false,
      });
      this.$store.dispatch("edit/updateState", {
        state: "dates",
        field: "endDate",
        subfield: "show",
        value: false,
      });
    },
    getDetailsByName(selectedName) {
      if (
        selectedName &&
        this.lists[this.selectedType].includes(selectedName)
      ) {
        const details = this.sheetsObj[this.selectedType].data.filter(
          (name) => name.name === selectedName
        )[0];
        this.$store.dispatch("edit/updateState", {
          state: "name",
          field: "id",
          value: details.id,
        });
        this.$store.dispatch("edit/updateState", {
          state: "name",
          field: "uuid",
          value: details.uuid,
        });
        if (details.tags) {
          var tags = details.tags.split(",");
          if (tags[0] === "") {
            tags = [];
          }
        }
        this.$store.dispatch("edit/updateState", {
          state: "tag",
          field: "selected",
          value: tags,
        });
        this.$store.dispatch("edit/updateState", {
          state: "description",
          value: details.description,
        });
        this.$store.dispatch("edit/updateState", {
          state: "location",
          field: "value",
          value: details.location,
        });
        this.$store.dispatch("edit/updateState", {
          state: "url",
          field: "value",
          value: details.url,
        });
        let businessBool;
        if (details.business) {
          if (details.business.toLowerCase() === "true") {
            businessBool = true;
          } else {
            businessBool = false;
          }
        }
        this.$store.dispatch("edit/updateState", {
          state: "business",
          field: "value",
          value: businessBool,
        });
        this.$store.dispatch("edit/updateState", {
          state: "dates",
          field: "startDate",
          subfield: "date",
          value: details.startDate,
        });
        this.$store.dispatch("edit/updateState", {
          state: "dates",
          field: "endDate",
          subfield: "date",
          value: details.endDate,
        });
      } else if (selectedName) {
        console.log(
          `selectName ${selectedName} of ${this.selectedType} does not exist and must be new`
        );
      } else {
        this.clearDetails();
      }
    },
    clearDetails() {
      this.$store.dispatch("edit/updateState", {
        state: "name",
        field: "newName",
        value: "",
      });
      this.$store.dispatch("edit/updateState", {
        state: "name",
        field: "id",
        value: "",
      });
      this.$store.dispatch("edit/updateState", {
        state: "name",
        field: "uuid",
        value: "",
      });
      this.$store.dispatch("edit/updateState", {
        state: "tag",
        field: "selected",
        value: [],
      });
      this.$store.dispatch("edit/updateState", {
        state: "description",
        value: "",
      });
      this.$store.dispatch("edit/updateState", {
        state: "location",
        field: "value",
        value: "",
      });
      this.$store.dispatch("edit/updateState", {
        state: "business",
        field: "value",
        value: false,
      });
      const date = new Date(new Date().setHours(12, 59, 0, 0))
        .toISOString()
        .substr(0, 10);
      this.$store.dispatch("edit/updateState", {
        state: "dates",
        field: "startDate",
        subfield: "date",
        value: date,
      });
      this.$store.dispatch("edit/updateState", {
        state: "dates",
        field: "endDate",
        subfield: "date",
        value: date,
      });
    },
    async upsertEditRecord() {
      if (this.$refs.editForm.validate()) {
        // Create the edit record i.e. sheet row
        const editRecord = this.createEditRecord();
        // Update row
        if (this.isAuthenticated) {
          try {
            let snackbarText;
            if (editRecord.newRecord) {
              this.insertEditRecord(editRecord);
              snackbarText = `${this.selectedName} of ${this.selectedType} created!`;
            } else {
              this.updateEditRecord(editRecord);
              snackbarText = `${this.selectedName} of ${this.selectedType} updated!`;
            }
            // get snackbar
            const snackbarColor = "secondary";
            this.getSnackbar(snackbarText, snackbarColor);
            // reset form
            this.$refs.editForm.reset();
            // hide fields
            this.resetEditFormShow();
          } catch (err) {
            console.error(err);
          }
        }
      } else {
        console.log("form is not valid and add button pushed");
      }
    },
    async deleteEditRecord() {
      if (this.$refs.editForm.validate()) {
        // if value is present
        if (this.id || this.uuid) {
          // get the index
          let index;
          this.sheetsObj[this.selectedType].data.forEach((name, idx) => {
            if (name.name === this.selectedName) {
              index = idx;
            }
          });
          // get the row number
          const rowNumber = index + 1;
          // delete row
          if (this.isAuthenticated) {
            const params = { spreadsheetId: this.sheetId };
            const batchUpdateSpreadsheetRequestBody = {
              requests: [
                {
                  deleteDimension: {
                    range: {
                      sheetId: this.sheetsObj[this.selectedType].sheetId,
                      dimension: "ROWS",
                      startIndex: index,
                      endIndex: rowNumber,
                    },
                  },
                },
              ],
            };
            const gapic = await this.$gapi.getGapiClient(); // init client
            await gapic.client.sheets.spreadsheets.batchUpdate(
              params,
              batchUpdateSpreadsheetRequestBody
            );
            // reget lists
            await this.getEditFormFields(this.sheetId, this.editSheets);
            // update sheetsobj
            this.getAllSheetsObj(this.sheetId, this.allSheets);
            // get snackbar
            const snackbarText = `${this.selectedName} of ${this.selectedType} deleted!`;
            const snackbarColor = "warning";
            this.getSnackbar(snackbarText, snackbarColor);
            // reset form and hide fields
            this.$refs.editForm.reset();
            this.resetEditFormShow();
          }
        } else {
          console.log("form is valid and delete button pushed, value is new");
        }
      } else {
        console.log("form is not valid and delete button pushed");
      }
    },
    createEditRecord() {
      let row;
      let tags;
      let id;
      let uuid;
      let newRecord;
      let rowNumber;
      let range;

      // Create a string from tags
      if (this.selectedTags) {
        tags = this.selectedTags.toString();
      } else {
        tags = "";
      }
      // Basic type row (most rows)
      const rowTypeBasic = [
        "spendCategory",
        "transactionType",
        "taxCategory",
        "exercise",
        "muscleGroup",
        "foodType",
        "payMethod",
        "receipt",
        "account",
      ];
      if (this.id && this.uuid) {
        id = this.id;
        uuid = this.uuid;
        newRecord = false;
      } else {
        id = this.sheetsObj[this.selectedType].maxId + 1;
        uuid = uuidv4();
        newRecord = true;
      }
      if (rowTypeBasic.includes(this.selectedType)) {
        row = [id, uuid, this.newName, tags, this.description];
      } else if (this.selectedType === "vendor") {
        row = [
          id,
          uuid,
          this.newName,
          tags,
          this.description,
          this.url,
          this.location,
        ];
      } else if (this.selectedType === "trip") {
        // Create sheetRow
        row = [
          id,
          uuid,
          this.newName,
          tags,
          this.description,
          this.location,
          this.business,
          this.startDate,
          this.endDate,
        ];
      }
      if (!newRecord) {
        // find the index to get the row number => rowNumber = index +1
        rowNumber =
          this.sheetsObj[this.selectedType].data.findIndex(
            (row) => row.id === this.id
          ) + 1;
        // create a range for the sheet to be updates => tag!A20 (row number)
        range = this.selectedType + "!A" + rowNumber;
      } else {
        range = this.selectedType;
      }
      console.log(range, row, newRecord);
      return { row: row, range: range, newRecord: newRecord };
    },
    async updateEditRecord(editRecord) {
      const gapic = await this.$gapi.getGapiClient(); // init client
      await gapic.client.sheets.spreadsheets.values.batchUpdate({
        spreadsheetId: this.sheetId,
        valueInputOption: "RAW",
        data: [
          {
            majorDimension: "ROWS",
            range: editRecord.range,
            values: [editRecord.row],
          },
        ],
      });
      await this.getEditFormFields(this.sheetId, this.editSheets);
      this.getAllSheetsObj(this.sheetId, this.allSheets);
    },
    async insertEditRecord(editRecord) {
      const range = this.selectedType;
      const gapic = await this.$gapi.getGapiClient(); // init client
      const params = {
        spreadsheetId: this.sheetId,
        valueInputOption: "RAW",
        range: range,
        insertDataOption: "INSERT_ROWS",
      };
      const valueRangeBody = {
        majorDimension: "ROWS",
        values: [editRecord.row],
      };
      await gapic.client.sheets.spreadsheets.values.append(
        params,
        valueRangeBody
      );
      await this.getEditFormFields(this.sheetId, this.editSheets);
      this.getAllSheetsObj(this.sheetId, this.allSheets);
    },
    getSnackbar(snackbarText, snackbarColor) {
      this.$store.dispatch("edit/updateState", {
        state: "snackbar",
        field: "text",
        value: snackbarText,
      });
      this.$store.dispatch("edit/updateState", {
        state: "snackbar",
        field: "color",
        value: snackbarColor,
      });
      this.$store.dispatch("edit/updateState", {
        state: "snackbar",
        field: "model",
        value: true,
      });
    },
    async createUUIDs(sheetId, sheet, rows) {
      if (this.isAuthenticated) {
        try {
          const gapic = await this.$gapi.getGapiClient(); // init client
          let uuids = [];
          for (let i = 0; i < rows; i++) {
            uuids.push(uuidv4());
          }
          const response = await gapic.client.sheets.spreadsheets.values.batchUpdate(
            {
              spreadsheetId: sheetId,
              valueInputOption: "RAW",
              data: [
                {
                  majorDimension: "COLUMNS",
                  range: sheet,
                  values: [uuids],
                },
              ],
            }
          );
          console.log(response);
        } catch (err) {
          console.error(err);
        }
      }
    },
  },
  mounted() {
    this.getEditFormFields(this.sheetId, this.editSheets);
    if (!this.sheetsObj[this.foodSheet]) {
      this.getAllSheetsObj(this.sheetId, this.allSheets);
    }
    // this.createUUIDs(this.sheetId, "trip!B2:B", 54);
  },
};
</script>
